import { Button } from "@material-ui/core";
import { InsertLink } from "@material-ui/icons";
import { copyToClipboard } from "./CommonFunctions";

export const mpaDetailColumns = (data) => {
  const list = [
    {
      Header: "Job Name",
      accessor: "job_name",
      Cell: (row) => {
        return (
          <div style={{ width: "319px" }}>
            {row.row.original.job_name || ""}
          </div>
        );
      },
    },
    {
      Header: "Total Applicants",
      accessor: "totalAppliedWorker",
    },
    {
      Header: "Total Workers",
      accessor: "totalReadyToWork",
    },
    {
      Header: "Job Link",
      accessor: "jobLink",
      Cell: (row) => {
        return row.row.original.jobLink ? (
          <Button
            className="flexDisplay blueButtonOutlined2 fontSize16"
            onClick={() => copyToClipboard(row.row.original.jobLink)}
          >
            <InsertLink
              style={{
                rotate: "135deg",
                color: "#1C4980",
              }}
            />
            Copy Link
          </Button>
        ) : (
          "-"
        );
      },
    },
  ];
  return list;
};

export const historyModalColumns = (getStatusLabel, getStatusStyle, Styles) => [
  {
    Header: "Lead Name",
    accessor: "name",
    Cell: ({ value }) => <p>{value}</p>,
  },
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
    Cell: ({ value }) => <p>{value}</p>,
  },
  {
    Header: "Current Status",
    accessor: "callStatus",
    Cell: ({ value }) => {
      const label = getStatusLabel(value);
      return (
        <span
          className={`${Styles.historyStatusBadge} ${getStatusStyle(label)}`}
        >
          {label}
        </span>
      );
    },
  },
  {
    Header: "Called On",
    accessor: "calledOnDate",
    Cell: ({ value }) => (
      <p>{value ? new Date(value).toLocaleDateString("en-IN") : "-"}</p>
    ),
  },
  {
    Header: "Call Attempts",
    accessor: "callAttempts",
    Cell: ({ value }) => <p>{value >= 5 ? "5+" : value}</p>,
  },
];

export const recruitmentDashboardColumns = () => {
  const list = [
    {
      Header: "Name",
      accessor: "name",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
    {
      Header: "Phone Number",
      accessor: "phoneNumber",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
    {
      Header: "Calling Date",
      accessor: "calledOnDate",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
    {
      Header: "Call Attempts",
      accessor: "callAttempts",
      defaultCanFilter: false,
      defaultCanSort: false,
    },
  ];
  return list;
};
